module.exports = __webpack_public_path__ + "media/images/audit-293556a0264b438f45778b2a035f7147.jpg";